import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {updateAccount,getAccounts} from '../store/teachActions';

const TeachItem = ({account,updateAccount,getAccounts}) => {
  const {sn,uid,uidNumber,gidNumber,homeDirectory,loginShell,mail} = account

  const [change, setChange] = useState(false);
  const [email, setEmail] = useState(mail);
  const [shell, setShell] = useState(loginShell);

  useEffect(()=>{
    setEmail(mail);
  },[mail]);

  useEffect(()=>{
    setShell(loginShell);
  },[loginShell]);

  useEffect(()=>{
    if(shell===loginShell && email===mail){
      setChange(false);
    }else{
      setChange(true);
    }
  //eslint-disable-next-line
  },[shell,email]);

  const onShellChange = e => {
    getAccounts();
    setShell(e.target.value);
  }

  const onChange = e => setEmail(e.target.value);

  const onSubmit = e => {
    e.preventDefault();
    updateAccount(uid,{shell,email});
    getAccounts();
    setChange(false);
  }

  return (
    <>
      { account &&
        <>
          <ul className='collection'>
            <div className='row collection-item light-blue lighten-5'>
              <li className='col s5'>{sn}</li>
              <li className='col s7'>{uid}</li>
            </div>

            <div className='row collection-item light-blue lighten-5'>
              <li className='col s5'>{uidNumber} / {gidNumber}</li>
              <li className='col s7'>{homeDirectory}</li>
            </div>

            <form onSubmit={onSubmit}>
              <div className='row collection-item light-blue lighten-5'>
                <li className='col s5'>
                  <div style={{'margin':'10px 0px 0px 2px','fontStyle':'italic'}}>
                    {shell}
                  </div>
                  
                  <div style={{'margin':'10px 0px 0px -15px'}}>
                <label className='col s6 left'>
                  <input checked={shell==='/bin/bash'} onChange={onShellChange} name='shell' value='/bin/bash' type='radio' className='with-gap' />
                  <span className='blue-grey-text text-darken-4'>bash</span>
                </label>
                <label className='col s6 left'>
                  <input checked={shell==='/sbin/nologin'} onChange={onShellChange} name='shell' value='/sbin/nologin' type='radio' className='with-gap' />
                  <span className='blue-grey-text text-darken-4'>nologin</span>
                </label>
                  </div>


                </li>
                <li className='col s7'>
                  <label htmlFor='email'>email</label>
                  <input type='text' name='email' value={email} onChange={onChange} style={{'fontStyle':'italic'}}/>
                </li>
              </div>
              <div className='row container' style={{'padding':'10px 10px 0px 20px'}}>
                <label className='col s6'>
                  <input disabled={!change} type='submit' value='update' className='btn btn-primary btn-block' />
                </label>
              </div>
            </form>
          </ul>
        </>
      }
    </>
  )
};

export default connect(null,{updateAccount,getAccounts})(TeachItem);
